export const DrawerMenuStyles = {
  a: {
    color: 'text',

    '&:hover, &:active, &:focus': {
      color: 'primary',
      textDecoration: 'none',
    },
  },
  '.drawer-menu__item': {
    display: 'block',
    paddingY: '2',
    color: 'text',
    fontSize: 'sm',
    fontWeight: 'semibold',
    lineHeight: 'tall',

    '&--link': {
      '&:hover, &:active, &:focus': {
        color: 'primary',
        textDecoration: 'none',
      },
    },

    '&--trigger': {
      display: 'flex',
      justifyContent: 'space-between',
      width: 'full',
      paddingX: 'none',
      textTransform: 'none',
      backgroundColor: 'transparent',
    },

    '&--placeholder, &--heading': {
      color: 'darkerGray',
    },

    '&--section-divider, &--heading': {
      paddingTop: '4',
      marginTop: '2',
      borderColor: 'lighterGray',
      borderStyle: 'solid',
      borderWidth: '1px 0 0',
    },

    '&--heading': {
      fontSize: 'md',
    },
  },

  '.drawer-menu-submenu': {
    paddingX: '4',
    margin: 'none',
    backgroundColor: 'lightestGray',
  },
};
